import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ButtonCancelDialogComponent } from '../button-cancel-dialog/button-cancel-dialog.component';
import { ButtonSaveComponent } from '../button-save/button-save.component';
import { AccionesDialog } from '@models/base/identificadores.model';

@Component({
  selector: 'app-dialog-edit-input-correo',
  standalone: true,
  imports: [CommonModule,FormsModule,MatDialogModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule,ButtonCancelDialogComponent,ButtonSaveComponent],
  templateUrl: './dialog-edit-input-correo.component.html',
  styleUrl: './dialog-edit-input-correo.component.css',
})
export class DialogEditInputComponent {
 correoForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DialogEditInputComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { correo: string },
    private fb: FormBuilder
  ) {
    this.correoForm = this.fb.group({
      correo: [data.correo || '', [Validators.required, Validators.email]]
    });
  }

  guardar(): void {
    if (this.correoForm.valid) {
      this.dialogRef.close(this.correoForm.value.correo);
      this.dialogRef.close({ event: AccionesDialog.Modificar, data: this.correoForm.value.correo });
    }
  }

  cancelar(): void {
    this.dialogRef.close();
  }
}
